import CheckMark from "../svg/CheckMark";
import "./ClientInfo/ClientInfo.css";
export default function RadioButton({ checked, setChecked }) {
  return (
    <div
      className="radioButton"
      onClick={() => setChecked(!checked)}
      role="checkbox"
      aria-checked={checked}
    >
      <div className="checkboxIcon">{checked && <CheckMark />}</div>
    </div>
  );
}
